import React from 'react';
import { Link } from 'react-router-dom';
import { formatHelpDate, getHelpArticlePath } from './helpFormat';

const NoticeList = ({ items, linkState }) => (
  <ul className="help-row-list">
    {items.map(item => (
      <li key={item.id}>
        <Link to={getHelpArticlePath(item.id)} state={linkState} className="help-row-list__item">
          <time className="help-row-list__date" dateTime={item.date}>{formatHelpDate(item.date)}</time>
          <span className="help-row-list__title">{item.title}</span>
        </Link>
      </li>
    ))}
  </ul>
);

export default NoticeList;
